import React from 'react';
import { FiMoon, FiSun } from 'react-icons/fi';
import { useTheme } from '../contexts/ThemeContext';
import './ThemeToggle.css';

interface ThemeToggleProps {
  className?: string;
  /**
   * "icon"  → botão circular minimalista (default)
   * "pill"  → pílula com texto "Claro / Escuro"
   */
  variant?: 'icon' | 'pill';
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ className, variant = 'icon' }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  const label = isDark ? 'Mudar para tema claro' : 'Mudar para tema escuro';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={`theme-toggle theme-toggle--${variant}${className ? ` ${className}` : ''}`}
      aria-label={label}
      title={label}
    >
      <span className="theme-toggle__icon" aria-hidden="true">
        {isDark ? <FiSun /> : <FiMoon />}
      </span>
      {variant === 'pill' && (
        <span className="theme-toggle__label">{isDark ? 'Claro' : 'Escuro'}</span>
      )}
    </button>
  );
};

export default ThemeToggle;
